import '../styles/main.scss';
import 'svgxuse';
import Barba from 'barba.js';
import smoothscroll from 'smoothscroll-polyfill';
import Util from './modules/utilities';
import Loader from './modules/Loader';
import Menu from './modules/Menu';
import Animation from './modules/Animation';
import Form from './modules/Form';
import FormValidator from './modules/FormValidator';

const isIE = !!window.MSInputMethodContext && !!document.documentMode;
isIE ? document.body.classList.add('ie') : false;

// DOM Loaded
document.addEventListener('DOMContentLoaded', () => {
  smoothscroll.polyfill();
  Util.forEachPolyfill();
  Util.anchorsInit();

  Barba.Prefetch.init();
  Barba.Pjax.start();
});

// Page Loaded
window.onload = () => {
  new Loader();
  setTimeout(() => new Animation(), 1300);
}

//Barba Transition
const CustomTransition = Barba.BaseTransition.extend({
  start() {
    /** メニュー表示時に追加した、ページのスクロール防止用クラスを削除 */
    document.querySelector('html').classList.remove('is-noscroll');
    this.loader = document.querySelector('[data-loader="loader"]');
    Promise.all([
      this.newContainerLoading,
      this.showLoader()
    ]).then(this.finish.bind(this));
  },

  showLoader() {
    return new Promise(resolve => {
      this.loader.classList.remove('is-loaded');
      this.loader.classList.remove('is-loading');
      this.loader.style.display = 'flex';
      setTimeout(() => this.loader.classList.add('is-loading'), 100);
      setTimeout(() => {
        resolve();
        this.loader.classList.add('is-loaded');
      }, 1200);
    });
  },

  finish() {
    window.scrollTo(0, 0);
    this.done();
    setTimeout(() => {
      this.loader.style.display = 'none';
      this.loader.classList.add('is-initial');
    }, 1800);
  }
});

Barba.Dispatcher.on('transitionCompleted', (currentStatus, oldStatus, container) => {
  new Menu();
  new Form();
  new FormValidator();
  Util.anchorsInit();
  setTimeout(() => new Animation(), 1200);
});

Barba.Dispatcher.on('newPageReady', (currentStatus, oldStatus, container, newPageRawHTML) => {
  // Googleアナリティクスへ送信
  dataLayer.push({
    'newPageUrl': location.pathname,
    event: 'pageLoaded'
  });
});

Barba.Pjax.getTransition = () => CustomTransition;
